import { render, staticRenderFns } from "./pageListAk.vue?vue&type=template&id=a8f5484a&scoped=true"
import script from "./pageListAk.vue?vue&type=script&lang=js"
export * from "./pageListAk.vue?vue&type=script&lang=js"
import style0 from "./pageListAk.vue?vue&type=style&index=0&id=a8f5484a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f5484a",
  null
  
)

export default component.exports